import request from '@/plugins/axios'

//获取图片包列表
export function listPicturePackage(params) {
  return request({
    url: '/picturePackage/listPicturePackage',
    method: 'get',
    params
  })
}

//添加图片包
export function addPicturePackage(data) {
  return request({
    url: '/picturePackage/addPicturePackage',
    method: 'post',
    data
  })
}

//删除图片包
export function deletePicturePackage(params) {
  return request({
    url: '/picturePackage/deletePicturePackage/' + params,
    method: 'get'
  })
}

//查询单个图片包
export function getPicturePackage(params) {
  return request({
    url: '/picturePackage/getPicturePackage/' + params,
    method: 'get'
  })
}

//修改图片包信息
export function updatePicturePackage(data) {
  return request({
    url: '/picturePackage/updatePicturePackage',
    method: 'post',
    data
  })
}